import { render } from "./VenueLayout.vue?vue&type=template&id=64f75676"
import script from "./VenueLayout.vue?vue&type=script&lang=js"
export * from "./VenueLayout.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__